import React, { Component } from "react";
import axios from "axios";
import 'react-tabs/style/react-tabs.css';
import './details.css';
import Header from "../../Header";
import { Link } from "react-router-dom";
const url = "https://bwapi.onrender.com/details"

class Details extends Component {
    constructor() {
        super()
        this.state = {
            details: '',
            categoryId:sessionStorage.getItem('categoryId'),
            userItem:'',
            productId:[]
        }

             
       
    }

    proceed =()=>{
     
        this.props.history.push(`/placeOrder/${this.state.details.product_name}`)
        sessionStorage.setItem("productItem",this.state.productId)
    }
    render() {
        return (
            <>
            <Header />
                <div classNameName="container">
                    <div className="single_product">
                        <div className="container-fluid" >
                            <div className="row">
                                <div className=" ditwid">
                                    <div className=" mt-2 img-magnifier-container">
                                        <img id="myimage" src={this.state.details.Image}
                                            data-toggle="magnify" className="bikeimg" alt="" />
                                    </div>
                                </div>
                                <div className="col-lg-4 order-3">
                                    <div className="product_description">
                                        <nav>
                                            <ol className="breadcrumb mt-1">
                                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                                <li className="breadcrumb-item active">Products</li>
                                            </ol>
                                        </nav>
                                        <div className="product_name">{this.state.details.product_name}</div>
                                        <div> <span className="product_price">₹ {this.state.details.Price} <span className="ex">Ex-Showroom price</span> </span> </div>
                                        <hr className="singleline" />
                                        <div>
                                            <span className="product_info">EMI starts at ₹ 2,000. <mark> No Cost EMI Available</mark></span>
                                            <br />
                                            <span className="product_info">In Stock: 25 units sold this week</span>
                                        </div>
                                        <hr className="singleline" />
                                        <div className="row mt-2">
                                            <div className="col-xs-6">
                                                <span className="product_options">
                                                    Color :
                                                </span>
                                                <br />
                                                <div className="mt-2 ">
                                                    <button className="btn btn-dark  btn-sm">Black</button>
                                                    <button className="btn btn-light ms-1 btn-sm">White</button>
                                                    <button className="btn btn-danger ms-1 btn-sm">Red</button>
                                                    <button className="btn btn-primary ms-1 btn-sm">Blue</button>
                                                </div>
                                                <br/>
                                                <span className="product_options">
                                                    Key specs :
                                                </span>
                                                <br />
                                                <div className="mt-2 d-flex" >
                                                    <button className="btn btn-warning  btn-sm">{this.state.details.Engine_Capacity} <i class="fab fa-keycdn"></i></button>
                                                    <button className="btn btn-warning ms-1 btn-sm">{this.state.details.Mileage} <i class="fas fa-gas-pump"></i></button>
                                                    <button className="btn btn-warning ms-1 btn-sm">{this.state.details.Transmission}<i class="fas fa-cogs"></i> </button>
                                                    <button className="btn btn-warning ms-1 btn-sm">{this.state.details.Weight} <i class="fas fa-weight"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr className="singleline" />
                                    <div className="row">
                                        <div className="col-xs-6"> 
                                        
                                        <button type="button" className="btn btn-primary mb-1 shop-button" onClick={this.proceed}>Add to Cart <i class="fa-solid fa-cart-plus"></i></button> 
                                        <Link to={`/listing/${this.state.categoryId}`}>
                                        <button type="button" className="btn btn-dark ms-2 mb-1 shop-button">Back <i class="fa-solid fa-backward"></i></button>
                                        </Link>
                                        <div className="product_fav"><i className="fas fa-heart"></i></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="accordion-item bg-secondary ">
                    <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                        <button className="accordion-button bg-info fw-bold fontfam" type="button" data-bs-toggle="collapse"
                            data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                            aria-controls="panelsStayOpen-collapseOne">
                            Specifications
                        </button>
                    </h2>
                    <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse show text"
                        aria-labelledby="panelsStayOpen-headingOne">
                        <div className="accordion-body">
                            <div className="">
                                <h3> <u>{this.state.details.product_name} Specifications & Features</u></h3>
                            </div>
                            <hr />
                            <div className="row">
                                <div className="col-md-12">
                                    <table className="col-md-12">
                                        <tbody>
                                            <tr className="row mt-10">
                                                <td className="col-md-4"><span className="p_specification exx">Engine Capacity :</span> </td>
                                                <td className="col-md-8">
                                                    <ul>
                                                        <li>{this.state.details.Engine_Capacity}</li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr className="row mt-10">
                                                <td className="col-md-4"><span className="p_specification exx">Mileage :</span> </td>
                                                <td className="col-md-8">
                                                    <ul>
                                                        <li> {this.state.details.Mileage} </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr className="row mt-10">
                                                <td className="col-md-4"><span className="p_specification exx">Transmission :</span> </td>
                                                <td className="col-md-8">
                                                    <ul>
                                                        <li>{this.state.details.Transmission}</li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr className="row mt-10">
                                                <td className="col-md-4"><span className="p_specification exx"> Weight :</span> </td>
                                                <td className="col-md-8">
                                                    <ul>
                                                        <li>{this.state.details.Weight}</li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr className="row mt-10">
                                                <td className="col-md-4"><span className="p_specification exx">Fuel Tank Capacity :</span> </td>
                                                <td className="col-md-8">
                                                    <ul>
                                                        <li>{this.state.details.Fuel_Tank_Capacity}</li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr className="row mt-10">
                                                <td className="col-md-4"><span className="p_specification exx">Seat Height :</span> </td>
                                                <td className="col-md-8">
                                                    <ul>
                                                        <li>{this.state.details.Seat_Height}</li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr className="row mt-10">
                                                <td className="col-md-4"><span className="p_specification exx">Top Speed :</span> </td>
                                                <td className="col-md-8">
                                                    <ul>
                                                        <li>{this.state.details.Top_Speed}</li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr className="row mt-10">
                                                <td className="col-md-4"><span className="p_specification exx">Ignition :</span> </td>
                                                <td className="col-md-8">
                                                    <ul>
                                                        <li>{this.state.details.Ignition}</li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr className="row mt-10">
                                                <td className="col-md-4"><span className="p_specification exx">Max Power :</span> </td>
                                                <td className="col-md-8">
                                                    <ul>
                                                        <li>{this.state.details.Max_Power}</li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr className="row mt-10">
                                                <td className="col-md-4"><span className="p_specification exx">Cooling System :</span> </td>
                                                <td className="col-md-8">
                                                    <ul>
                                                        <li>{this.state.details.Cooling_System}</li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr className="row mt-10">
                                                <td className="col-md-4"><span className="p_specification exx">Braking System :</span> </td>
                                                <td className="col-md-8">
                                                    <ul>
                                                        <li>{this.state.details.Braking_System}</li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr className="row mt-10">
                                                <td className="col-md-4"><span className="p_specification exx">Speedometer :</span> </td>
                                                <td className="col-md-8">
                                                    <ul>
                                                        <li>{this.state.details.Speedometer}</li>
                                                    </ul>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                

            </>
        )
    }
    async componentDidMount() {
      let productItem=[]
        productItem.push(this.props.location.search.split('=')[1])
        console.log(productItem,"prodId chek")
        this.setState({productId:productItem})
     
        let prodId = this.props.location.search.split('=')[1];
        this.setState({productItem:prodId})

        let response = await axios.get(`${url}/${prodId}`, { method: 'GET' })
        this.setState({ details: response.data[0] })
    }
}
export default Details;